/**
 * Theme utility functions for managing the Academy marketing theme.
 *
 * The marketing theme extends the current HubSpot theme with Marketing brand colors.
 * Uses a separate localStorage key to avoid conflicting with HubSpot's theme system.
 */

/**
 * Gets the Academy marketing theme preference from localStorage.
 * Uses a separate key to avoid conflicting with HubSpot's theme system.
 */
export const getMarketingThemePreference = () => {
  try {
    return localStorage.getItem('academy:marketing-theme') === 'true';
  } catch (error) {
    return false;
  }
};